// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"46c427e8","489":"8d76a8b6","576":"0c2678a4","729":"2511ba87","785":"2b0b6577","787":"89b78079","864":"f6fd2d90","910":"47b9424a","912":"5218741f","931":"4e400359"}[chunkId] + ".chunk.js";
};